import { ComponentProps, ReactNode } from 'react';

import { cn } from '@frontend/lib/utils';
import { isInsideClassName } from '@frontend/shared/util/webHelpers';
import { Editor, EditorContent } from '@tiptap/react';

export interface AnswerEditorProps {
  editor: Editor | null;
  children?: ReactNode;
  className?: string;
}

export function AnswerEditor({
  editor,
  children,
  className,
  ...divProps
}: AnswerEditorProps & ComponentProps<'div'>) {
  return (
    <div
      className={cn('js-focus-parent relative pb-2', className)}
      onClick={(e) => {
        // Focus when clicking surrounding container.
        if (
          (e.target as HTMLElement).tagName !== 'BUTTON' &&
          !isInsideClassName(e.target as HTMLElement, 'ProseMirror')
        ) {
          editor?.commands.focus();
        }
      }}
      {...divProps}
    >
      <EditorContent
        editor={editor}
        style={{
          minHeight: '50px',
        }}
      />
      {children}
    </div>
  );
}
